/* ---- AI问数：业务主题推荐问数语句 + 模拟返回数据 ---- */

export interface AiQueryRecommendation {
  id: string
  topicId: string
  query: string
  description: string
}

export interface AiQueryResult {
  query: string
  resultType: 'table' | 'chart'
  title: string
  columns: { key: string; label: string }[]
  rows: Record<string, string | number>[]
  summary?: string
}

// 每个业务主题的推荐问数语句
export const TOPIC_RECOMMENDED_QUERIES: AiQueryRecommendation[] = [
  // 代发客群资金交易明细主题
  {
    id: 'q-payroll-1',
    topicId: 'topic-payroll',
    query: '2026年5月代发工资TOP10客户是哪些？',
    description: '按当月累计代发工资金额排序，查看头部客户',
  },
  {
    id: 'q-payroll-2',
    topicId: 'topic-payroll',
    query: '各分行代发客户数量和金额分布情况',
    description: '按所属分行汇总代发客户规模和工资金额',
  },
  {
    id: 'q-payroll-3',
    topicId: 'topic-payroll',
    query: '2026年4月与5月代发工资金额变化趋势',
    description: '对比两个月代发工资金额环比变化',
  },

  // 对公大额存款变动情况
  {
    id: 'q-corp-1',
    topicId: 'topic-corp-deposit',
    query: '近30天对公大额存款变动超过1000万的客户有哪些？',
    description: '筛选大额存款变动显著的客户',
  },
  {
    id: 'q-corp-2',
    topicId: 'topic-corp-deposit',
    query: '各分行对公存款余额排名',
    description: '按分行维度汇总对公存款余额并排序',
  },

  // 零售客户信息
  {
    id: 'q-retail-1',
    topicId: 'topic-retail-1',
    query: '各风险等级零售客户数量和占比',
    description: '按风险等级统计零售客户分布',
  },

  // 零售存款业务分析
  {
    id: 'q-retail-3',
    topicId: 'topic-retail-3',
    query: '各期限存款规模和利率结构分析',
    description: '按存款期限维度分析存款结构',
  },

  // 对公存款信息
  {
    id: 'q-corp-dep-1',
    topicId: 'topic-corp-1',
    query: '对公活期与定期存款比例变化',
    description: '分析对公存款结构中活期/定期占比趋势',
  },

  // 对公客户画像分析
  {
    id: 'q-corp-profile',
    topicId: 'topic-corp-2',
    query: '企业客户行业分布和授信额度统计',
    description: '按行业分类统计企业客户数量和授信总额',
  },

  // 金融市场业务分析
  {
    id: 'q-market-1',
    topicId: 'topic-market-1',
    query: '本月债券投资和同业业务规模对比',
    description: '对比金融市场主要业务类型规模',
  },

  // 风险资产分类统计
  {
    id: 'q-risk-1',
    topicId: 'topic-risk-1',
    query: '各分支行五级分类不良率排名',
    description: '按分支行统计不良贷款率并排序',
  },

  // 授信业务明细
  {
    id: 'q-risk-2',
    topicId: 'topic-risk-2',
    query: '各担保方式授信金额分布',
    description: '按担保方式统计授信业务规模和占比',
  },

  // 分支行考核指标
  {
    id: 'q-finance-1',
    topicId: 'topic-finance-1',
    query: '各分支行存贷款任务完成率',
    description: '查看各分支机构考核指标完成情况',
  },

  // 网点效能分析
  {
    id: 'q-ops-1',
    topicId: 'topic-ops-1',
    query: '网点业务办理量排名和客户满意度',
    description: '按网点统计业务量和客户满意度评分',
  },

  // 运营流程优化分析
  {
    id: 'q-ops-2',
    topicId: 'topic-ops-2',
    query: '业务流程各环节平均耗时分析',
    description: '分析业务流程各节点处理效率和瓶颈',
  },

  // 各机构存款情况统计
  {
    id: 'q-corp-branch-1',
    topicId: 'topic-corp-branch-deposit',
    query: '海珠中心支行各支行对公存款时点余额排名',
    description: '按支行维度汇总对公存款时点余额并排序',
  },
  {
    id: 'q-corp-branch-2',
    topicId: 'topic-corp-branch-deposit',
    query: '近5个统计时点对公及个人存款变化趋势',
    description: '对比不同统计日期的对公与个人存款变化',
  },

  // 监管报送数据核对
  {
    id: 'q-reg-1',
    topicId: 'topic-reg-1',
    query: '本月监管报送数据差异项统计',
    description: '统计报送数据中的差异和异常项数量',
  },

  // ---- 首页最新上线主题补充 ----
  // 客户资金流向分析 (topic-1)
  {
    id: 'q-latest-1-1',
    topicId: 'topic-1',
    query: '近30天客户资金流向TOP5方向是哪些？',
    description: '按资金流向维度统计TOP5方向',
  },
  {
    id: 'q-latest-1-2',
    topicId: 'topic-1',
    query: '各渠道资金流入流出对比',
    description: '按渠道维度分析资金流入流出差异',
  },

  // 信贷资产质量监测 (topic-2)
  {
    id: 'q-latest-2-1',
    topicId: 'topic-2',
    query: '近6个月不良贷款率变化趋势',
    description: '查看不良贷款率月度变化趋势',
  },
  {
    id: 'q-latest-2-2',
    topicId: 'topic-2',
    query: '各分支行不良贷款分布情况',
    description: '按分支行维度统计不良贷款分布',
  },

  // 对公客户画像分析 (topic-3)
  {
    id: 'q-latest-3-1',
    topicId: 'topic-3',
    query: '对公客户行业分布统计',
    description: '按行业维度统计对公客户分布',
  },
  {
    id: 'q-latest-3-2',
    topicId: 'topic-3',
    query: '对公客户日均存款规模分析',
    description: '统计对公客户日均存款规模分布',
  },

  // 金融市场业务分析 (topic-4)
  {
    id: 'q-latest-4-1',
    topicId: 'topic-4',
    query: '本月同业业务收入排名',
    description: '按业务类型统计同业收入排名',
  },
  {
    id: 'q-latest-4-2',
    topicId: 'topic-4',
    query: '债券投资收益率变化趋势',
    description: '查看近3个月债券投资收益率走势',
  },

  // 监管报送数据核对 (topic-5)
  {
    id: 'q-latest-5-1',
    topicId: 'topic-5',
    query: '本月监管报送数据差异项统计',
    description: '统计报送数据中的差异和异常项',
  },
  {
    id: 'q-latest-5-2',
    topicId: 'topic-5',
    query: '各报送机构数据质量排名',
    description: '按报送机构维度评估数据质量',
  },

  // 零售存款业务分析 (topic-6)
  {
    id: 'q-latest-6-1',
    topicId: 'topic-6',
    query: '近3个月零售存款规模变化趋势',
    description: '查看零售存款月度规模变化',
  },
  {
    id: 'q-latest-6-2',
    topicId: 'topic-6',
    query: '各期限存款产品占比分析',
    description: '按存款期限维度分析产品结构',
  },
]

// 模拟 AI 返回结果
const MOCK_RESULTS: Record<string, AiQueryResult> = {
  // 代发工资TOP10
  'q-payroll-1': {
    query: '2026年5月代发工资TOP10客户是哪些？',
    resultType: 'chart',
    title: '2026年5月代发工资金额TOP10客户',
    summary: '2026年5月共统计 25 位代发客户，累计代发工资总额 ¥513,400.00，TOP10客户占比 62.3%。',
    columns: [
      { key: 'rank', label: '排名' },
      { key: 'name', label: '客户姓名' },
      { key: 'amount', label: '当月累计代发工资金额' },
      { key: 'company', label: '代发单位' },
    ],
    rows: [
      { rank: 1, name: '赵明辉', amount: '¥52,000.00', company: '深圳前海金融控股集团' },
      { rank: 2, name: '陈雪梅', amount: '¥42,000.00', company: '深圳福田金融控股' },
      { rank: 3, name: '张浩然', amount: '¥35,000.00', company: '广州黄埔实业集团' },
      { rank: 4, name: '孙伟明', amount: '¥28,500.00', company: '深圳宝安金融科技' },
      { rank: 5, name: '周建华', amount: '¥26,800.00', company: '深圳宝安金融科技' },
      { rank: 6, name: '吴建国', amount: '¥22,000.00', company: '东莞南城科技' },
      { rank: 7, name: '刘芳菲', amount: '¥21,000.00', company: '佛山顺德金融控股' },
      { rank: 8, name: '黄伟强', amount: '¥23,500.00', company: '东莞虎门科技产业' },
      { rank: 9, name: '周文杰', amount: '¥19,500.00', company: '惠州惠阳投资发展集团' },
      { rank: 10, name: '赵美玲', amount: '¥18,600.00', company: '广州越秀投资' },
    ],
  },

  // 各分行代发分布
  'q-payroll-2': {
    query: '各分行代发客户数量和金额分布情况',
    resultType: 'chart',
    title: '各分行代发客户分布',
    summary: '广州分行代发客户数和金额均居首位，深圳前海客户单客平均工资金额最高。',
    columns: [
      { key: 'branch', label: '分行' },
      { key: 'count', label: '客户数' },
      { key: 'totalAmount', label: '工资金额合计' },
      { key: 'avgAmount', label: '户均工资金额' },
    ],
    rows: [
      { branch: '广州分行', count: 9, totalAmount: '¥191,600.00', avgAmount: '¥21,289.00' },
      { branch: '佛山分行', count: 7, totalAmount: '¥127,600.00', avgAmount: '¥18,229.00' },
      { branch: '东莞分行', count: 5, totalAmount: '¥102,500.00', avgAmount: '¥20,500.00' },
      { branch: '惠州分行', count: 4, totalAmount: '¥91,700.00', avgAmount: '¥22,925.00' },
    ],
  },

  // 4月vs5月趋势
  'q-payroll-3': {
    query: '2026年4月与5月代发工资金额变化趋势',
    resultType: 'chart',
    title: '代发工资金额月度对比',
    summary: '5月累计代发工资 ¥513,400.00，较4月 ¥497,200.00 增长 3.26%，整体呈现稳步上升趋势。',
    columns: [
      { key: 'month', label: '月份' },
      { key: 'totalAmount', label: '累计代发工资金额' },
      { key: 'customerCount', label: '代发客户数' },
      { key: 'change', label: '环比变化' },
    ],
    rows: [
      { month: '2026年4月', totalAmount: '¥497,200.00', customerCount: 25, change: '—' },
      { month: '2026年5月', totalAmount: '¥513,400.00', customerCount: 25, change: '+3.26%' },
    ],
  },

  // 对公大额存款变动
  'q-corp-1': {
    query: '近30天对公大额存款变动超过1000万的客户有哪些？',
    resultType: 'table',
    title: '对公大额存款变动TOP客户（>1000万）',
    summary: '近30天共 8 户对公客户存款变动超过1000万元，合计变动金额 ¥12,350万元。',
    columns: [
      { key: 'customer', label: '客户名称' },
      { key: 'branch', label: '开户行' },
      { key: 'change', label: '变动金额(万元)' },
      { key: 'balance', label: '当前余额(万元)' },
      { key: 'date', label: '变动日期' },
    ],
    rows: [
      { customer: '广州城市建设投资集团', branch: '广州分行营业部', change: '+3,200', balance: '15,680', date: '2026-06-04' },
      { customer: '深圳腾讯科技有限公司', branch: '深圳南山支行', change: '+2,850', balance: '22,350', date: '2026-06-03' },
      { customer: '比亚迪汽车有限公司', branch: '深圳福田支行', change: '+1,980', balance: '18,200', date: '2026-06-02' },
      { customer: '佛山美的集团', branch: '佛山顺德支行', change: '+1,560', balance: '9,800', date: '2026-06-01' },
      { customer: '东莞华为终端有限公司', branch: '东莞松山湖支行', change: '+1,200', balance: '12,500', date: '2026-05-30' },
      { customer: '广州南沙港务集团', branch: '广州南沙支行', change: '-1,100', balance: '6,200', date: '2026-05-29' },
      { customer: '惠州TCL科技', branch: '惠州惠城支行', change: '+1,080', balance: '8,600', date: '2026-05-28' },
      { customer: '珠海格力电器', branch: '珠海香洲支行', change: '+480', balance: '11,200', date: '2026-05-27' },
    ],
  },

  // 对公存款余额排名
  'q-corp-2': {
    query: '各分行对公存款余额排名',
    resultType: 'chart',
    title: '各分行对公存款余额排名',
    summary: '广州分行对公存款余额居首，深圳分行紧随其后。',
    columns: [
      { key: 'rank', label: '排名' },
      { key: 'branch', label: '分行' },
      { key: 'balance', label: '对公存款余额(亿元)' },
    ],
    rows: [
      { rank: 1, branch: '广州分行', balance: '186.5' },
      { rank: 2, branch: '深圳分行', balance: '158.2' },
      { rank: 3, branch: '佛山分行', balance: '72.8' },
      { rank: 4, branch: '东莞分行', balance: '65.3' },
      { rank: 5, branch: '惠州分行', balance: '42.1' },
      { rank: 6, branch: '珠海分行', balance: '38.6' },
    ],
  },

  // 零售客户风险等级分布
  'q-retail-1': {
    query: '各风险等级零售客户数量和占比',
    resultType: 'chart',
    title: '零售客户风险等级分布',
    summary: '保守型和稳健型客户占比合计 78.5%，是我行零售客户主力群体。',
    columns: [
      { key: 'level', label: '风险等级' },
      { key: 'count', label: '客户数' },
      { key: 'percentage', label: '占比' },
    ],
    rows: [
      { level: '保守型', count: '352,000', percentage: '38.2%' },
      { level: '稳健型', count: '370,800', percentage: '40.3%' },
      { level: '平衡型', count: '112,500', percentage: '12.2%' },
      { level: '成长型', count: '58,600', percentage: '6.4%' },
      { level: '进取型', count: '27,100', percentage: '2.9%' },
    ],
  },

  // 存款结构分析
  'q-retail-3': {
    query: '各期限存款规模和利率结构分析',
    resultType: 'chart',
    title: '零售存款期限结构',
    summary: '活期存款占比 42.5%，一年期定期占比最大（28.3%），整体存款结构合理。',
    columns: [
      { key: 'term', label: '存款期限' },
      { key: 'amount', label: '存款规模(亿元)' },
      { key: 'rate', label: '平均利率(%)' },
      { key: 'percentage', label: '占比' },
    ],
    rows: [
      { term: '活期', amount: '125.6', rate: '0.25', percentage: '42.5%' },
      { term: '3个月定期', amount: '32.8', rate: '1.35', percentage: '11.1%' },
      { term: '6个月定期', amount: '28.5', rate: '1.55', percentage: '9.6%' },
      { term: '1年定期', amount: '83.6', rate: '1.75', percentage: '28.3%' },
      { term: '2年定期', amount: '15.2', rate: '2.25', percentage: '5.1%' },
      { term: '3年定期', amount: '10.1', rate: '2.75', percentage: '3.4%' },
    ],
  },

  // 对公活期vs定期
  'q-corp-dep-1': {
    query: '对公活期与定期存款比例变化',
    resultType: 'chart',
    title: '对公存款结构变化趋势',
    summary: '近6个月对公活期存款占比逐月下降，企业存款定期化趋势明显。',
    columns: [
      { key: 'month', label: '月份' },
      { key: 'current', label: '活期存款(亿元)' },
      { key: 'fixed', label: '定期存款(亿元)' },
      { key: 'ratio', label: '活期占比' },
    ],
    rows: [
      { month: '2026年1月', current: '218.5', fixed: '286.3', ratio: '43.2%' },
      { month: '2026年2月', current: '210.2', fixed: '295.8', ratio: '41.5%' },
      { month: '2026年3月', current: '205.6', fixed: '308.2', ratio: '40.0%' },
      { month: '2026年4月', current: '198.3', fixed: '318.5', ratio: '38.3%' },
      { month: '2026年5月', current: '192.1', fixed: '328.6', ratio: '36.9%' },
      { month: '2026年6月', current: '188.5', fixed: '335.2', ratio: '35.9%' },
    ],
  },

  // 企业客户行业分布
  'q-corp-profile': {
    query: '企业客户行业分布和授信额度统计',
    resultType: 'chart',
    title: '企业客户行业分布',
    summary: '制造业和批发零售业合计占比超50%，授信集中度较高。',
    columns: [
      { key: 'industry', label: '行业' },
      { key: 'count', label: '客户数' },
      { key: 'creditAmount', label: '授信总额(亿元)' },
      { key: 'percentage', label: '客户占比' },
    ],
    rows: [
      { industry: '制造业', count: '3,856', creditAmount: '128.5', percentage: '32.3%' },
      { industry: '批发和零售业', count: '2,520', creditAmount: '68.2', percentage: '21.1%' },
      { industry: '房地产业', count: '1,280', creditAmount: '95.6', percentage: '10.7%' },
      { industry: '建筑业', count: '1,150', creditAmount: '52.3', percentage: '9.6%' },
      { industry: '信息技术', count: '980', creditAmount: '35.8', percentage: '8.2%' },
      { industry: '其他', count: '2,154', creditAmount: '72.1', percentage: '18.1%' },
    ],
  },

  // 金融市场业务对比
  'q-market-1': {
    query: '本月债券投资和同业业务规模对比',
    resultType: 'chart',
    title: '金融市场主要业务规模',
    summary: '债券投资余额 356.8亿元，同业业务余额 128.5亿元，债券投资占比 73.5%。',
    columns: [
      { key: 'type', label: '业务类型' },
      { key: 'amount', label: '余额(亿元)' },
      { key: 'percentage', label: '占比' },
    ],
    rows: [
      { type: '债券投资', amount: '356.8', percentage: '73.5%' },
      { type: '同业拆借', amount: '68.2', percentage: '14.1%' },
      { type: '同业存款', amount: '38.5', percentage: '7.9%' },
      { type: '回购交易', amount: '21.8', percentage: '4.5%' },
    ],
  },

  // 五级分类不良率
  'q-risk-1': {
    query: '各分支行五级分类不良率排名',
    resultType: 'table',
    title: '各分支行不良贷款率排名',
    summary: '全行平均不良贷款率 1.52%，佛山分行不良率最高（2.18%），需重点关注。',
    columns: [
      { key: 'rank', label: '排名' },
      { key: 'branch', label: '分支行' },
      { key: 'total', label: '贷款总额(亿元)' },
      { key: 'npl', label: '不良贷款(亿元)' },
      { key: 'nplRate', label: '不良率' },
    ],
    rows: [
      { rank: 1, branch: '佛山分行', total: '85.6', npl: '1.87', nplRate: '2.18%' },
      { rank: 2, branch: '东莞分行', total: '72.3', npl: '1.35', nplRate: '1.87%' },
      { rank: 3, branch: '惠州分行', total: '48.5', npl: '0.82', nplRate: '1.69%' },
      { rank: 4, branch: '珠海分行', total: '52.1', npl: '0.78', nplRate: '1.50%' },
      { rank: 5, branch: '深圳分行', total: '186.2', npl: '2.56', nplRate: '1.37%' },
      { rank: 6, branch: '广州分行', total: '215.8', npl: '2.42', nplRate: '1.12%' },
    ],
  },

  // 担保方式分布
  'q-risk-2': {
    query: '各担保方式授信金额分布',
    resultType: 'chart',
    title: '授信担保方式分布',
    summary: '抵押贷款占比最大（45.2%），信用贷款占比 22.8%。',
    columns: [
      { key: 'type', label: '担保方式' },
      { key: 'amount', label: '授信金额(亿元)' },
      { key: 'count', label: '业务笔数' },
      { key: 'percentage', label: '占比' },
    ],
    rows: [
      { type: '抵押', amount: '215.6', count: '8,520', percentage: '45.2%' },
      { type: '保证', amount: '102.3', count: '12,350', percentage: '21.5%' },
      { type: '信用', amount: '108.5', count: '18,600', percentage: '22.8%' },
      { type: '质押', amount: '35.8', count: '2,150', percentage: '7.5%' },
      { type: '其他', amount: '14.2', count: '1,860', percentage: '3.0%' },
    ],
  },

  // 分支行考核
  'q-finance-1': {
    query: '各分支行存贷款任务完成率',
    resultType: 'table',
    title: '分支行存贷款任务完成情况',
    summary: '广州分行和深圳分行任务完成率居前，佛山分行存款完成率偏低。',
    columns: [
      { key: 'branch', label: '分支行' },
      { key: 'depositTarget', label: '存款完成率' },
      { key: 'loanTarget', label: '贷款完成率' },
      { key: 'overall', label: '综合评分' },
    ],
    rows: [
      { branch: '广州分行', depositTarget: '98.5%', loanTarget: '95.2%', overall: '96.8' },
      { branch: '深圳分行', depositTarget: '96.2%', loanTarget: '97.8%', overall: '97.0' },
      { branch: '珠海分行', depositTarget: '92.1%', loanTarget: '88.5%', overall: '90.3' },
      { branch: '东莞分行', depositTarget: '89.6%', loanTarget: '91.2%', overall: '90.4' },
      { branch: '惠州分行', depositTarget: '85.3%', loanTarget: '82.6%', overall: '84.0' },
      { branch: '佛山分行', depositTarget: '82.5%', loanTarget: '86.8%', overall: '84.7' },
    ],
  },

  // 网点效能
  'q-ops-1': {
    query: '网点业务办理量排名和客户满意度',
    resultType: 'table',
    title: '网点业务办理量TOP10',
    summary: '广州天河支行日均业务量居首，客户满意度 96.2%。',
    columns: [
      { key: 'rank', label: '排名' },
      { key: 'branch', label: '网点' },
      { key: 'dailyAvg', label: '日均业务量' },
      { key: 'satisfaction', label: '客户满意度' },
      { key: 'waitTime', label: '平均等候(分钟)' },
    ],
    rows: [
      { rank: 1, branch: '广州天河支行', dailyAvg: 386, satisfaction: '96.2%', waitTime: '12' },
      { rank: 2, branch: '深圳南山支行', dailyAvg: 352, satisfaction: '95.8%', waitTime: '15' },
      { rank: 3, branch: '广州越秀支行', dailyAvg: 318, satisfaction: '94.5%', waitTime: '18' },
      { rank: 4, branch: '深圳福田支行', dailyAvg: 298, satisfaction: '93.2%', waitTime: '20' },
      { rank: 5, branch: '佛山禅城支行', dailyAvg: 265, satisfaction: '92.8%', waitTime: '22' },
      { rank: 6, branch: '东莞松山湖支行', dailyAvg: 248, satisfaction: '94.1%', waitTime: '14' },
      { rank: 7, branch: '珠海香洲支行', dailyAvg: 235, satisfaction: '91.5%', waitTime: '25' },
      { rank: 8, branch: '惠州惠城支行', dailyAvg: 212, satisfaction: '90.2%', waitTime: '28' },
    ],
  },

  // 流程耗时分析
  'q-ops-2': {
    query: '业务流程各环节平均耗时分析',
    resultType: 'chart',
    title: '业务流程各环节平均耗时',
    summary: '贷款审批环节平均耗时最长（3.2天），是主要瓶颈。',
    columns: [
      { key: 'stage', label: '环节' },
      { key: 'avgTime', label: '平均耗时(天)' },
      { key: 'maxTime', label: '最大耗时(天)' },
      { key: 'passRate', label: '一次通过率' },
    ],
    rows: [
      { stage: '客户申请', avgTime: '0.3', maxTime: '1', passRate: '98.5%' },
      { stage: '资料审核', avgTime: '0.8', maxTime: '3', passRate: '92.3%' },
      { stage: '风险评估', avgTime: '1.5', maxTime: '5', passRate: '88.6%' },
      { stage: '贷款审批', avgTime: '3.2', maxTime: '10', passRate: '82.1%' },
      { stage: '合同签订', avgTime: '0.5', maxTime: '2', passRate: '95.8%' },
      { stage: '放款执行', avgTime: '0.6', maxTime: '2', passRate: '97.2%' },
    ],
  },

  // 监管报送差异
  'q-reg-1': {
    query: '本月监管报送数据差异项统计',
    resultType: 'table',
    title: '监管报送数据差异项统计',
    summary: '本月共发现 15 项数据差异，较上月减少 8 项，数据质量持续改善。',
    columns: [
      { key: 'category', label: '差异类型' },
      { key: 'count', label: '差异项数' },
      { key: 'status', label: '处理状态' },
      { key: 'impact', label: '影响程度' },
    ],
    rows: [
      { category: '金额不一致', count: 5, status: '已处理 3 项', impact: '高' },
      { category: '字段缺失', count: 4, status: '已处理 2 项', impact: '中' },
      { category: '分类错误', count: 3, status: '已处理 3 项', impact: '中' },
      { category: '格式不规范', count: 3, status: '已处理 2 项', impact: '低' },
    ],
  },

  // 各支行对公存款排名
  'q-corp-branch-1': {
    query: '海珠中心支行各支行对公存款时点余额排名',
    resultType: 'chart',
    title: '海珠中心支行各支行对公存款时点余额排名',
    summary: '截至2026年6月10日，昌岗路支行对公存款时点余额居首（1,568.20万元），工业大道北支行次之（1,235.80万元）。',
    columns: [
      { key: 'rank', label: '排名' },
      { key: 'subbranch', label: '支行' },
      { key: 'corpDeposit', label: '对公存款时点(万元)' },
      { key: 'personalDeposit', label: '个人存款时点(万元)' },
      { key: 'corpAvg', label: '对公年日均(万元)' },
    ],
    rows: [
      { rank: 1, subbranch: '昌岗路支行', corpDeposit: '1,568.20', personalDeposit: '428.50', corpAvg: '1,482.60' },
      { rank: 2, subbranch: '工业大道北支行', corpDeposit: '1,235.80', personalDeposit: '356.80', corpAvg: '1,156.30' },
      { rank: 3, subbranch: '赤岗支行', corpDeposit: '1,058.60', personalDeposit: '298.20', corpAvg: '1,012.80' },
      { rank: 4, subbranch: '广州保利天悦支行', corpDeposit: '896.50', personalDeposit: '268.90', corpAvg: '856.20' },
      { rank: 5, subbranch: '广州华南支行', corpDeposit: '785.30', personalDeposit: '215.60', corpAvg: '742.50' },
      { rank: 6, subbranch: '敦和支行', corpDeposit: '652.80', personalDeposit: '186.40', corpAvg: '628.90' },
      { rank: 7, subbranch: '广州广报中心支行', corpDeposit: '528.60', personalDeposit: '156.20', corpAvg: '498.30' },
    ],
  },

  // 近5个统计时点变化趋势
  'q-corp-branch-2': {
    query: '近5个统计时点对公及个人存款变化趋势',
    resultType: 'chart',
    title: '近5个统计时点存款变化趋势',
    summary: '2026年以来对公存款总体呈稳步增长态势，6月10日对公存款合计6,725.80万元，较年初（2025年12月31日）增长约8.5%。',
    columns: [
      { key: 'statDate', label: '统计日期' },
      { key: 'corpDeposit', label: '对公存款合计(万元)' },
      { key: 'personalDeposit', label: '个人存款合计(万元)' },
      { key: 'corpChange', label: '对公环比变化' },
    ],
    rows: [
      { statDate: '2025-12-31', corpDeposit: '6,200.50', personalDeposit: '1,680.20', corpChange: '—' },
      { statDate: '2026-03-31', corpDeposit: '6,385.20', personalDeposit: '1,756.80', corpChange: '+2.98%' },
      { statDate: '2026-05-31', corpDeposit: '6,580.60', personalDeposit: '1,825.40', corpChange: '+3.06%' },
      { statDate: '2026-06-09', corpDeposit: '6,698.30', personalDeposit: '1,896.50', corpChange: '+1.79%' },
      { statDate: '2026-06-10', corpDeposit: '6,725.80', personalDeposit: '1,910.60', corpChange: '+0.41%' },
    ],
  },

  // ---- 首页最新上线主题模拟结果 ----
  'q-latest-1-1': {
    query: '近30天客户资金流向TOP5方向是哪些？',
    resultType: 'chart',
    title: '近30天客户资金流向TOP5',
    summary: '近30天资金流出主要方向为理财购买、贷款还款、定期存款、转账他行及消费支出。',
    columns: [
      { key: 'direction', label: '资金流向' },
      { key: 'amount', label: '流出金额（亿元）' },
      { key: 'count', label: '笔数（万笔）' },
    ],
    rows: [
      { direction: '理财购买', amount: '12.5', count: '3.2' },
      { direction: '贷款还款', amount: '9.8', count: '1.8' },
      { direction: '定期存款', amount: '7.6', count: '2.1' },
      { direction: '转账他行', amount: '5.3', count: '4.5' },
      { direction: '消费支出', amount: '3.2', count: '8.6' },
    ],
  },
  'q-latest-1-2': {
    query: '各渠道资金流入流出对比',
    resultType: 'table',
    title: '各渠道资金流入流出对比',
    summary: '手机银行渠道资金流动最为活跃，网银次之。',
    columns: [
      { key: 'channel', label: '渠道' },
      { key: 'inflow', label: '流入（亿元）' },
      { key: 'outflow', label: '流出（亿元）' },
      { key: 'net', label: '净流入（亿元）' },
    ],
    rows: [
      { channel: '手机银行', inflow: '28.5', outflow: '25.3', net: '+3.2' },
      { channel: '网上银行', inflow: '15.2', outflow: '14.8', net: '+0.4' },
      { channel: '柜面', inflow: '8.6', outflow: '6.2', net: '+2.4' },
      { channel: 'ATM', inflow: '1.2', outflow: '2.1', net: '-0.9' },
    ],
  },
  'q-latest-2-1': {
    query: '近6个月不良贷款率变化趋势',
    resultType: 'chart',
    title: '近6个月不良贷款率变化趋势',
    summary: '近6个月不良贷款率总体呈下降趋势，从1.85%降至1.52%。',
    columns: [
      { key: 'month', label: '月份' },
      { key: 'npl', label: '不良贷款率（%）' },
      { key: 'balance', label: '不良贷款余额（亿元）' },
    ],
    rows: [
      { month: '2025-12', npl: '1.85', balance: '42.3' },
      { month: '2026-01', npl: '1.78', balance: '40.8' },
      { month: '2026-02', npl: '1.72', balance: '39.5' },
      { month: '2026-03', npl: '1.65', balance: '37.2' },
      { month: '2026-04', npl: '1.58', balance: '35.8' },
      { month: '2026-05', npl: '1.52', balance: '34.1' },
    ],
  },
  'q-latest-2-2': {
    query: '各分支行不良贷款分布情况',
    resultType: 'table',
    title: '各分支行不良贷款分布情况',
    summary: '广州分行不良贷款余额最高，深圳分行不良贷款率最低。',
    columns: [
      { key: 'branch', label: '分支行' },
      { key: 'nplBalance', label: '不良贷款余额（亿元）' },
      { key: 'nplRate', label: '不良贷款率（%）' },
      { key: 'totalLoans', label: '总贷款（亿元）' },
    ],
    rows: [
      { branch: '广州分行', nplBalance: '8.5', nplRate: '1.68', totalLoans: '506.2' },
      { branch: '深圳分行', nplBalance: '6.2', nplRate: '1.25', totalLoans: '496.0' },
      { branch: '佛山分行', nplBalance: '3.8', nplRate: '1.72', totalLoans: '220.9' },
      { branch: '东莞分行', nplBalance: '2.9', nplRate: '1.55', totalLoans: '187.1' },
    ],
  },
  'q-latest-3-1': {
    query: '对公客户行业分布统计',
    resultType: 'chart',
    title: '对公客户行业分布统计',
    summary: '制造业企业占比最高达28%，其次为批发零售业和建筑业。',
    columns: [
      { key: 'industry', label: '行业' },
      { key: 'count', label: '客户数（户）' },
      { key: 'pct', label: '占比（%）' },
    ],
    rows: [
      { industry: '制造业', count: '356', pct: '28' },
      { industry: '批发零售业', count: '245', pct: '19' },
      { industry: '建筑业', count: '198', pct: '15' },
      { industry: '科技服务', count: '168', pct: '13' },
      { industry: '房地产', count: '142', pct: '11' },
    ],
  },
  'q-latest-3-2': {
    query: '对公客户日均存款规模分析',
    resultType: 'table',
    title: '对公客户日均存款规模分析',
    summary: '日均存款500万以上客户占比12%，贡献了65%的对公存款总额。',
    columns: [
      { key: 'range', label: '日均存款区间' },
      { key: 'count', label: '客户数（户）' },
      { key: 'totalDeposit', label: '存款总额（亿元）' },
    ],
    rows: [
      { range: '500万以上', count: '156', totalDeposit: '89.5' },
      { range: '100-500万', count: '428', totalDeposit: '32.6' },
      { range: '50-100万', count: '356', totalDeposit: '12.8' },
      { range: '50万以下', count: '312', totalDeposit: '3.2' },
    ],
  },
  'q-latest-4-1': {
    query: '本月同业业务收入排名',
    resultType: 'chart',
    title: '本月同业业务收入排名',
    summary: '债券投资业务收入最高，占总同业收入的42%。',
    columns: [
      { key: 'bizType', label: '业务类型' },
      { key: 'revenue', label: '收入（万元）' },
      { key: 'pct', label: '占比（%）' },
    ],
    rows: [
      { bizType: '债券投资', revenue: '1,856', pct: '42' },
      { bizType: '同业拆借', revenue: '986', pct: '22' },
      { bizType: '票据转贴', revenue: '756', pct: '17' },
      { bizType: '同业存放', revenue: '523', pct: '12' },
      { bizType: '其他', revenue: '298', pct: '7' },
    ],
  },
  'q-latest-4-2': {
    query: '债券投资收益率变化趋势',
    resultType: 'chart',
    title: '近3个月债券投资收益率走势',
    summary: '近3个月债券投资收益率整体平稳，5月略有上升。',
    columns: [
      { key: 'month', label: '月份' },
      { key: 'yield', label: '年化收益率（%）' },
      { key: 'duration', label: '平均久期（年）' },
    ],
    rows: [
      { month: '2026-03', yield: '3.25', duration: '2.8' },
      { month: '2026-04', yield: '3.18', duration: '2.6' },
      { month: '2026-05', yield: '3.32', duration: '2.9' },
    ],
  },
  'q-latest-5-1': {
    query: '本月监管报送数据差异项统计',
    resultType: 'table',
    title: '监管报送数据差异项统计',
    summary: '本月共发现 8 项数据差异，均已在报送前完成修复。',
    columns: [
      { key: 'reportType', label: '报表类型' },
      { key: 'diffCount', label: '差异项数' },
      { key: 'status', label: '状态' },
    ],
    rows: [
      { reportType: 'G01资产负债比例', diffCount: '2', status: '已修复' },
      { reportType: 'G11资产质量', diffCount: '3', status: '已修复' },
      { reportType: 'G14授信集中', diffCount: '1', status: '已修复' },
      { reportType: 'S72制造业融资', diffCount: '2', status: '已修复' },
    ],
  },
  'q-latest-5-2': {
    query: '各报送机构数据质量排名',
    resultType: 'table',
    title: '各报送机构数据质量排名',
    summary: '运营管理部数据质量评分最高，风险管理部位居第二。',
    columns: [
      { key: 'org', label: '报送机构' },
      { key: 'score', label: '质量评分' },
      { key: 'errorCount', label: '差错项数' },
    ],
    rows: [
      { org: '运营管理部', score: '98.5', errorCount: '1' },
      { org: '风险管理部', score: '96.2', errorCount: '3' },
      { org: '公司金融部', score: '94.8', errorCount: '4' },
      { org: '零售金融部', score: '93.5', errorCount: '5' },
    ],
  },
  'q-latest-6-1': {
    query: '近3个月零售存款规模变化趋势',
    resultType: 'chart',
    title: '近3个月零售存款规模变化趋势',
    summary: '近3个月零售存款规模稳步增长，5月新增存款12.8亿元。',
    columns: [
      { key: 'month', label: '月份' },
      { key: 'balance', label: '存款余额（亿元）' },
      { key: 'change', label: '环比增长（%）' },
    ],
    rows: [
      { month: '2026-03', balance: '285.6', change: '1.2' },
      { month: '2026-04', balance: '292.3', change: '2.3' },
      { month: '2026-05', balance: '305.1', change: '4.4' },
    ],
  },
  'q-latest-6-2': {
    query: '各期限存款产品占比分析',
    resultType: 'chart',
    title: '各期限存款产品占比分析',
    summary: '一年期定期存款占比最高，活期存款占比有所下降。',
    columns: [
      { key: 'term', label: '存款期限' },
      { key: 'balance', label: '余额（亿元）' },
      { key: 'pct', label: '占比（%）' },
    ],
    rows: [
      { term: '活期', balance: '78.5', pct: '25.7' },
      { term: '三个月', balance: '42.3', pct: '13.9' },
      { term: '半年期', balance: '56.8', pct: '18.6' },
      { term: '一年期', balance: '89.2', pct: '29.2' },
      { term: '二年期', balance: '38.3', pct: '12.6' },
    ],
  },
}

/** 根据推荐问数ID获取模拟结果 */
export function getAiQueryResult(queryId: string): AiQueryResult | undefined {
  return MOCK_RESULTS[queryId]
}

/** 获取某主题下的推荐问数列表 */
export function getTopicQueries(topicId: string): AiQueryRecommendation[] {
  return TOPIC_RECOMMENDED_QUERIES.filter(q => q.topicId === topicId)
}
